import { APP_NAME } from '@/constants';
import { useTitle } from '@vueuse/core';

export const useBTitle = (title: string) => {
  useTitle(`${title} | ${APP_NAME}`);
};
